import type { ProjectView } from '@/types/current-project';
import { executionMilestones, milestoneBudget } from './project-presentation';

export interface ProjectPayment {
  key: string;
  title: string;
  amount: string;
  paid: boolean;
  frozen: boolean;
}
// A project-state summary, not an invented transaction ledger or bank history.
export function projectPayments(
  project: ProjectView,
  account: string
): ProjectPayment[] {
  const payments: ProjectPayment[] = [];
  const payer = account === project.client;
  const coordinator = account === project.coordinator;
  if (
    (payer || coordinator) &&
    project.planning.quote &&
    (project.planning.status === 'Completed' || project.planning.escrow !== '0')
  ) {
    payments.push({
      key: 'planning',
      title: 'Planning fee',
      amount: project.planning.quote.fee,
      paid: project.planning.status === 'Completed',
      frozen: project.planning.frozen || !!project.activeDisputeId,
    });
  }
  for (const milestone of executionMilestones(project)) {
    const assigned = new Set(
      milestone.assignments
        .filter((a) => a.worker === account)
        .map((a) => a.requirementKey)
    );
    if (!payer && !coordinator && !assigned.size) continue;
    const amount = payer
      ? milestoneBudget(milestone)
      : milestone.definition.requirements
          .filter((r) => assigned.has(r.key))
          .reduce(
            (sum, r) => sum + BigInt(r.budget),
            coordinator ? BigInt(milestone.definition.coordinatorFee) : 0n
          )
          .toString();
    payments.push({
      key: milestone.milestoneId,
      title: milestone.definition.title,
      amount,
      paid: milestone.status === 'Completed',
      frozen:
        project.cancelled || !!project.activeDisputeId || milestone.frozen,
    });
  }
  return payments;
}
export function paymentTotal(payments: ProjectPayment[]) {
  return payments
    .reduce((sum, payment) => sum + BigInt(payment.amount), 0n)
    .toString();
}
